<template>
  <div class="device-monitor" ref="monitorEl" :style="{ '--font-size': `${fontSize}px` }">
    <Header />
    <Menu v-show="hasMenuAndStateReport" ref="menuRef" @node-click="handleNodeClick" />
    <StateReport v-show="hasMenuAndStateReport" ref="reportRef" />

    <CupsuleButton v-if="hasAsideToolBar" v-bind="rightButtonConfig" />

    <router-view></router-view>
  </div>
</template>

<script>
import Header from './components/Header';
import Menu from './components/Menu';
import StateReport from './components/StateReport';

import CupsuleButton from '@/components/button/cupsule.vue';

import Type from '@/store/mutation-type';

import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  components: { Header, Menu, StateReport, CupsuleButton },
  data() {
    return {
      activeDevice: {},
      sceneData: {},
      guide: null,
      rightButtonConfig: {
        expandWidth: '120px',
        options: [
          {
            text: '任务列表',
            icon: 'iconfont icon-device-list',
            style: { '--shadow-color': '#fa8c16', color: '#fa8c16' },
            state: 0,
            stateColorList: ['#fa8c16', 'inherit'],
            title: '任务列表是否显示',
            // basicText: '任务列表',
            // stateList: ['(已展开)', '(已关闭)'],
            onClick: item => {
              item.state = +!item.state;

              this.$refs.menuRef.changeCollapse();

              // item.text = item.basicText + item.stateList[item.state];
              item.style.color = item.stateColorList[item.state];
              item.style['--shadow-color'] = item.stateColorList[item.state];
            }
          },
          {
            text: '状态报告',
            title: '状态报告是否显示',
            icon: 'iconfont icon-state-report',
            style: { '--shadow-color': '#fa8c16', color: '#fa8c16' },
            stateColorList: ['#fa8c16', 'inherit'],
            state: 0,
            onClick: item => {
              item.state = +!item.state;

              item.style.color = item.stateColorList[item.state];
              item.style['--shadow-color'] = item.stateColorList[item.state];

              this.$refs.reportRef.changeCollapse();
            }
          }
        ]
      }
    };
  },
  provide() {
    return {
      getMonitorCtx: () => this,
      getSceneData: () => this.sceneData,
      getActiveDevice: () => this.activeDevice,
      getMonitorEl: () => this.$refs.monitorEl
    };
  },
  computed: {
    ...mapState('device', ['monitorMode', 'monitorConfig']),
    ...mapState('admin', ['profile']),
    ...mapState('socket', ['deviceTree']),
    ...mapGetters('device', ['modeMap']),
    hasAsideToolBar() {
      const list = ['map', 'scene'];
      return list.includes(this.monitorMode);
    },
    fontSize() {
      return this.monitorConfig.fontSize;
    },
    hasMenuAndStateReport() {
      const list = ['home', 'list', 'alarm'];
      return !list.includes(this.monitorMode);
    }
  },
  methods: {
    ...mapMutations('device', {
      setMonitorMenuActive: Type.SET_MONITOR_MENU_ACTIVE,
      setMonitorMenuDefaultActive: Type.SET_MONITOR_MENU_DEFAULT_ACTIVE
    }),
    handleNodeClick(info) {
      this.setMonitorMenuActive(info);
    },
    showGuide() {
      this.guide = this.$notify({
        title: '提示',
        message: `任务列表右键可跳转详情`,
        type: 'info',
        duration: 0
      });
    },
    handleMonitorModeChange(n) {
      let name = this.modeMap[n || 'map'].componentName;

      if (name === 'deviceMap' && this.profile.mapTile) {
        name += '2';
      }

      this.$router.push({ name });
    }
  },
  created() {
    this.setMonitorMenuDefaultActive(this.deviceTree[0]);
  },
  watch: {
    monitorMode: {
      handler: 'handleMonitorModeChange',
      immediate: true
    },
    $route(n) {
      if (n.fullPath !== '/devices/monitor') return;
      this.handleMonitorModeChange(this.monitorMode);
    }
  }
};
</script>

<style lang="scss">
.device-monitor {
  position: relative;
  height: 100%;
}
</style>
